import React from "react";
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

const LoadingBackdrop = ({ isLoading, message }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 200, // Ensure it's higher than Dialog
        backgroundColor: `rgba(0, 0, 0, ${message ? 0.8 : 0.5})`,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
      open={isLoading}
    >
      <CircularProgress size={40} thickness={4} color="inherit" />
      {message && (
        <Typography variant="h6" sx={{ mt: 1 }}>
          {message}
        </Typography>
      )}
    </Backdrop>
  );
};

export default LoadingBackdrop;
